<template>
<div class="chapter">
<div class="inner_page">
<p class="p3">For Patricia, who has always been there to encourage me. I probably wouldn’t be where I am now if we hadn’t met online. And to Michael, who gave me the courage to start writing in the first place.</p>
<p> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?b9fd1f68